import { useState, useRef, useEffect } from 'react';
import classnames from 'classnames';
import aligncenter from './image/aligncenter.svg';
import alignleft from './image/alignleft.svg';
import alignright from './image/alignright.svg';
import downtrangle from './image/downtrangle.svg';
import { Popover, PopoverTrigger, PopoverContent } from '@leadsnavi/ui-kit';
import * as EditorTypeAll from '../tinymce.d';
import {
  DROPDOWN_ARROW_STYLE,
  DROPDOWN_MENU_ITEM_STYLE,
  DROPDOWN_MENU_WRAPPER_STYLE,
  DROPDOWN_TRIGGER_STYLE,
} from './ThemeConstant';

interface Props {
  editorInstance: EditorTypeAll.Editor;
}

const defaultAligns = [
  { value: 'JustifyCenter', icon: aligncenter },
  { value: 'JustifyLeft', icon: alignleft },
  { value: 'JustifyRight', icon: alignright },
];

const AlignItems = ({ editorInstance }: Props) => {
  const btnRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [selectAlign, setSelectAlign] = useState(alignleft); // Default to left align
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (editorInstance) {
      editorInstance.on('NodeChange', (event: { element: Element }) => {
        const textAlign = editorInstance.dom.getStyle(event.element, 'textAlign', true);
        let currentAlign = alignleft; // Default to left
        let hasActiveAlign = false;

        if (textAlign === 'center') {
          currentAlign = aligncenter;
          hasActiveAlign = true;
        } else if (textAlign === 'right') {
          currentAlign = alignright;
          hasActiveAlign = true;
        } else if (textAlign === 'left') {
          currentAlign = alignleft;
          hasActiveAlign = true;
        }

        setSelectAlign(currentAlign);
        setIsActive(hasActiveAlign && textAlign !== 'left'); // Only show active for non-default alignments
      });
    }
  }, [editorInstance]);

  const selectAlignCl = (align: { icon: string; value: string }) => {
    if (!editorInstance) return;
    setSelectAlign(align.icon);
    editorInstance.execCommand(align.value, false, align.value);
    setOpen(false);
  };

  const alignActionCompact = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.stopPropagation(); // 阻止触发 Popover 打开
    const align = defaultAligns.find(i => i.icon === selectAlign);
    align && editorInstance.execCommand(align.value, false, align.value);
  };

  return (
    <Popover open={open} onOpenChange={setOpen} modal={true}>
      <div ref={btnRef} className={classnames(['inline-flex '])}>
        {/* 主按钮：点击执行对齐命令 */}
        <span className={classnames(...DROPDOWN_TRIGGER_STYLE)} onClick={alignActionCompact}>
          <img width="18px" height="18px" src={selectAlign} />
        </span>

        {/* 下拉箭头：点击打开菜单 */}
        <PopoverTrigger asChild>
          <span className={classnames(...DROPDOWN_ARROW_STYLE, isActive && 'bg-[#E5E5E5] hover:bg-[#E5E5E5]')}>
            <img width="5px" height="4px" src={downtrangle} />
          </span>
        </PopoverTrigger>
      </div>
      <PopoverContent
        className={classnames(...DROPDOWN_MENU_WRAPPER_STYLE)}
        side="top"
        align="center"
        sideOffset={5}
        style={{ zIndex: 9999 }}
      >
        <div className="text-xs">
          <div className="p-0.5">
            {defaultAligns.map((align, index) => (
              <div
                key={index}
                className={classnames([...DROPDOWN_MENU_ITEM_STYLE, align.icon === selectAlign && 'bg-[#E5E5E5]'])}
                onClick={() => {
                  selectAlignCl(align);
                }}
              >
                <img width="20px" height="20px" src={align.icon} />
              </div>
            ))}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default AlignItems;
